import { render } from "./Pagination.vue?vue&type=template&id=ea66d02e&scoped=true&ts=true&lang=html"
import script from "./Pagination.vue?vue&type=script&lang=ts"
export * from "./Pagination.vue?vue&type=script&lang=ts"

import "./Pagination.vue?vue&type=style&index=0&id=ea66d02e&lang=scss&scoped=true"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-ea66d02e"]])

export default __exports__